<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="acquisition">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 采集网关管理
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="toAddNew">新增</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="名称">
                <el-input placeholder="请输入名称" v-model="seefrom.name"></el-input>
              </el-form-item>
              <el-form-item label="IP">
                <el-input placeholder="请输入IP" v-model="seefrom.ip"></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/acquisition/findAll"
            :parent="self"
            :config="config"
            :other="other"
            ref="acquisitionList"
          >
            <template slot="last">
              <el-table-column label="关联RTU">
                <template slot-scope="scope">
                  <el-link @click="detail(scope.$index, scope.row)">详情</el-link>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="toEdit(scope.$index, scope.row, true)"
                  >编辑</el-link>
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteMsg(scope.$index, scope.row)"
                  >删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <el-dialog
          class="editDialog"
          :visible.sync="displayForm"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form ref="addEquipment" :model="addEquipment" :rules="rules">
            <el-form-item label="名称" prop="name">
              <el-input placeholder="请输入名称" v-model="addEquipment.name"></el-input>
            </el-form-item>
            <el-form-item label="ip" prop="ip">
              <el-input placeholder="请输入IP" v-model="addEquipment.ip"></el-input>
            </el-form-item>
            <el-form-item label="端口" prop="port">
              <el-input placeholder="请输入端口" v-model="addEquipment.port"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="displayForm = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitForm">确 定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        ip: [{ required: true, message: "请输入IP", trigger: "blur" }],
        port: [{ required: true, message: "请输入端口", trigger: "blur" }]
      },
      title: "",
      displayForm: false,
      tabName: "acquisition",
      loading: true,
      form_jsgl: {},
      showTable: true,
      other: {},
      items: [],
      seefrom: {
        name: "",
        ip: ""
      },
      addEquipment: {
        name: "",
        ip: "",
        port: ""
      },
      status: "",
      id: ""
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "名称"
        },
        {
          prop: "ip",
          label: "IP"
        },
        {
          prop: "port",
          label: "端口"
        }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable")
  },
  methods: {
    //详情
    detail(index, row) {
      this.$router.push({name: 'RTU', params: {id: row.id}})
    },
    //搜索
    subSeefrom() {
      this.other = this.seefrom;
      this.$nextTick(this.$refs.acquisitionList.getData);
    },
    //重置
    reset() {
      this.seefrom = {};
    },
    //新增
    toAddNew() {
      this.title = "新增网关";
      this.status = 1;
      this.displayForm = true;
      this.addEquipment = {
        name: "",
        ip: "",
        port: ""
      };
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //修改
    toEdit(index, row) {
      this.title = "编辑网关";
      this.status = 2;
      this.displayForm = true;
      this.addEquipment.name = row.name;
      this.addEquipment.ip = row.ip;
      this.addEquipment.port = row.port;
      this.id = row.id;
      if (this.$refs["addEquipment"])
        this.$refs["addEquipment"].clearValidate();
    },
    //确认
    submitForm() {
      this.$refs["addEquipment"].validate(valid => {
        if (valid) {
          if (this.status === 1) {
            //console.log(this.addEquipment.ip,"ip")
            this.$axiospost("operation/acquisition/save", {
                name: this.addEquipment.name,
                ip: this.addEquipment.ip,
                port: this.addEquipment.port
            }).then(res => {
              this.$message.success("新增成功！");
              this.displayForm = false;
              this.subSeefrom();
            });
          } else if (this.status === 2) {
            this.$axiospost("operation/acquisition/save", {
                id: this.id,
                name: this.addEquipment.name,
                ip: this.addEquipment.ip,
                port: this.addEquipment.port
            }).then(res => {
              this.$message.success("修改成功！");
              this.displayForm = false;
              this.subSeefrom();
            });
          }
        }
      });
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm("是否删除该网关？", "删除操作", {
        cancelButton: "取消",
        confirmButton: "确定",
        type: "warning"
      }).then(() => {
        this.$axiosdelete("operation/acquisition/delete", {
          params: {
            id: row.id
          }
        }).then(res => {
          this.$message.success("删除成功！")
          this.subSeefrom();
        });
      });
    }
  }
};
</script>

<style lang="less">
.content {
  .w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
    z-index: 99;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/acquisitionGate.vue